<template>
  <!-- <el-dialog
    :title=" $t('addressSearch')"
    :visible.sync="centerPointDialogVisible"
    class="centerPointDialog"
    @close="cancelSetting()"
    :close-on-click-modal="false"
    :append-to-body="true"
  > -->
  <div class="centerPointDialog" v-drag>
    <el-form :model="centerForm" ref="centerForm">
      <div class="">
        <el-form-item :label="$t('searchM')" :label-width="formLabelWidth" class="form-input">
          <el-input
            v-model="centerForm.name"
            autocomplete="off"
            :placeholder="$t('enterAddress')"
            clearable
            @change="searchPlace"
            @focus="focusAddress"
            @clear="focusAddress"
          >
          </el-input>
          <div class="places" :style="showAddress && places.length > 0 ? 'display: block' : 'display: none'">
            <div class="place" v-for="(item, index) in places" :key="index" @click="selectPlace(item)">
              <div class="searchIcon" :class="[isDefaultTheme ? 'dayFence' : 'nightFence_m']"></div>
              <div class="place-content">
                <span class="placeName">{{ item.name }}</span>
                <span class="place-address">{{ item.address }}</span>
              </div>
              <div class="center-point" @click="_updateMapCenter(item)">{{ $t('setAsCenterPoint') }}</div>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="updateCenter()">确定</el-button>
      <el-button @click="cancelSetting()">取消</el-button>
    </div> -->
    <!-- </el-dialog> -->
  </div>
</template>
<script>
import { updateMapCenter } from '@/api/fence'
import { getCoordinate, getGeographic } from '@/common/map'
import { setSession } from '@/api/common'
import { mapGetters } from 'vuex'
export default {
  props: {
    centerPointDialogVisible: {
      default: false,
      typeOf: Boolean,
    },
  },
  data() {
    return {
      showAddress: false,
      formLabelWidth: '60px',
      centerForm: {
        name: '',
      },
      places: [],
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  methods: {
    selectPlace(val) {
      if (!val || !val.lonlat) return
      let point = val.lonlat.split(',')
      let center = {
        lng: point[0],
        lat: point[1],
      }
      this.showAddress = false
      this.$emit('changePoint', center)
    },
    // 输入地点搜索
    searchPlace(val) {
      if (!val) {
        this.showAddress = false
        this.places = []
        return
      }
      getGeographic(val, this.handlePlaces)
      this.showAddress = true
    },
    focusAddress() {
      if (!this.centerForm.name) {
        this.showAddress = false
        this.places = []
        return
      }
      this.showAddress = true
    },
    // 返回的地点列表
    handlePlaces(obj) {
      this.places = []
      if (obj.pois && obj.pois.length > 0) {
        obj.pois.map(item => {
          if (
            item.address !== '缅甸' &&
            item.address !== '日本' &&
            item.address !== '朝鲜' &&
            item.address !== '蒙古' &&
            item.address !== '老挝' &&
            item.address !== '韩国'
          ) {
            this.places.push(item)
          }
        })
      }
    },
    cancelSetting() {
      this.$emit('update:centerPointDialogVisible', false)
      this.centerForm.name = ''
      // this.$nextTick(function() {
      //   this.$refs[formName].resetFields()
      // })
    },
    updateCenter() {
      if (!this.centerForm.name) {
        this.$message({
          type: 'error',
          message: this.$t('enterTheLocation'),
        })
        return
      }
    },
    _updateMapCenter(obj) {
      console.log(obj)
      if (!obj || !obj.lonlat) return
      let point = obj.lonlat.split(',')
      let param = {
        lng: point[0],
        lat: point[1],
      }
      updateMapCenter(JSON.stringify(param)).then(res => {
        if (res.state === 0) {
          this.$store.commit('handleCenterPoint', param)
          this.$message({
            type: 'success',
            message: '设置中心点成功!',
          })
          setSession('centerPoint', JSON.stringify(param))
          this.$emit('changePoint', param)
          this.$emit('update:centerPointDialogVisible', false)
          this.showAddress = false
        }
      })
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.centerPointDialog
  position: absolute
  top: 80px
  left: 320px
  z-index 999
  width 420px;/*no*/
  >>>.el-input
    width 300px!important
  >>>.el-input--suffix .el-input__inner
    background: var(--search-input-bg)
    color: var(--black-color)
    border: var(--search-input-border);
  >>>.el-form-item__label
    border none
    border-radius 4px 0 0 4px
    background var(--search-btn-bg)
    color var(--search-btn-color)
    text-align: center
    padding: 0
    line-height: 36px
  >>>.el-form-item__content
    line-height: 36px
  >>>.el-input__inner
    line-height: 36px
    height: 36px

.form-input
  position: relative
  .places
    position absolute
    left -60px
    top 42px;/*no*/
    width 430px;/*no*/
    height: 400px
    // max-height: 400px
    overflow-y: auto
    // text-align: center
    background-color: var(--new-input-bg);
    border: solid 1px var(--new-common-blue);
    color: var(--new-color-white);
    border-radius: 8px
    .place
      line-height: 40px
      cursor pointer
      margin: 10px 0 0 15px
      display: flex
      align-items: center;
      position: relative
      .dayFence
        width 24px
        height 24px
        bg-image('~@/icon/place_search.png')
        background-size 100%
        margin-right: 15px
      .nightFence_m
        width 24px
        height 24px
        bg-image('~@/icon/place_m.png')
        background-size 100%
        margin-right: 15px
      .place-content
        width calc(100% - 135px)
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
      .place-address
        margin-left: 10px
        color: #999
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap

      .center-point
        position: absolute
        right: 10px
        top: 50%
        transform: translateY(-50%)
        padding: 0px 5px
        line-height: 30px
        border-radius: 5px
        background-color: var(--button-blue)
        color: var(--btn-color);
</style>
